<template>
  <div class="main print-no-padding drugsManagement">
    <el-card>
      <searchBar :search-params="searchParams" @change="change" @search="search" />
      <div class="handle-bar">
        <el-button size="small" class="btn" @click="handleExcelExport">导出药品</el-button>
        <el-button size="small" class="btn" @click="handleExcelModal">批量导入药品</el-button>
        <el-button size="small" class="btn" @click="$router.push('/drugsManagement/add')">添加药品</el-button>
        <el-button v-if="!isBatchMode" size="small" class="btn batch-delete-btn" @click="enterBatchMode">
          批量删除
        </el-button>
        <template v-else>
          <el-button
            size="small"
            class="btn delete-selected-btn"
            type="danger"
            :disabled="selectedDrugs.length === 0"
            @click="deleteSelectedDrugs"
          >
            删除选中药品({{ selectedDrugs.length }})
          </el-button>
          <el-button size="small" class="btn" @click="cancelBatchMode">取消</el-button>
        </template>
      </div>
      <drugsManagementTable
        :page-no="searchParams.pageNo"
        :page-size="searchParams.pageSize"
        :data="data"
        :total="total"
        :show-selection="isBatchMode"
        @handle-pageNo="handlePageNo"
        @handle-pageSize="handlePageSize"
        @refresh="init"
        @selection-change="handleSelectionChange"
        ref="drugTable"
      />
    </el-card>
    <uploadExcel :visible="visible" @close="handleExcelModal" @refresh="search" />
  </div>
</template>

<script>
import Fetch from '@/api';
import searchBar from './components/searchBar';
import drugsManagementTable from './components/drugsManagementTable';
import uploadExcel from './components/uploadExcel';
import { MessageBox } from 'element-ui';
import router from '../../router';

export default {
  name: 'cashDrugList',
  components: {
    searchBar,
    drugsManagementTable,
    uploadExcel
  },
  data() {
    return {
      visible: false,
      isBatchMode: false,
      selectedDrugs: [],
      searchParams: {
        name: '',
        barcode: '',
        drugCode: '',
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    enterBatchMode() {
      this.isBatchMode = true;
    },
    cancelBatchMode() {
      this.isBatchMode = false;
      this.selectedDrugs = [];
      if (this.$refs.drugTable) {
        this.$refs.drugTable.clearSelection();
      }
    },
    handleSelectionChange(selection) {
      this.selectedDrugs = selection;
    },
    deleteSelectedDrugs() {
      if (this.selectedDrugs.length === 0) {
        this.$message.warning('请先选择要删除的药品');
        return;
      }

      this.$confirm(
        `确定要删除选中的 ${this.selectedDrugs.length} 个药品吗？删除后将把该药品从药店药品库移除`,
        '确认批量删除药品',
        {
          confirmButtonText: '我再想想',
          cancelButtonText: '删除',
          customClass: 'confirm',
          distinguishCancelAndClose: true,
          center: true
        }
      )
        .then(() => {})
        .catch(type => {
          if (type === 'cancel') {
            this.performBatchDelete();
          }
        });
    },
    async performBatchDelete() {
      try {
        const deletePromises = this.selectedDrugs.map(drug => {
          return Fetch.deleteCompanyDrugByBarcodeOrSpuId({
            companySpuId: drug.spuId,
            companySkuId: drug.skuId
          });
        });

        await Promise.all(deletePromises);
        this.$message.success(`成功删除 ${this.selectedDrugs.length} 个药品`);
        this.cancelBatchMode();
        this.init(); // 刷新列表
      } catch (error) {
        this.$message.error('批量删除失败，请重试');
        console.error('批量删除失败:', error);
      }
    },
    handleExcelModal() {
      this.visible = !this.visible;
    },
    change(key, val) {
      this.searchParams[key] = val;
    },
    fetchDrugPage(params) {
      return Fetch.query_company_drug_page(params).then(({ data, pageNo, pageSize, totalCount }) => {
        this.data = data;
        this.total = totalCount;
        this.searchParams.pageNo = pageNo;
        this.searchParams.pageSize = pageSize;
      });
    },
    init() {
      // 获取药店是否支持商品编码及导入模板地址
      this.$store.dispatch('drugsManagement/FetchDrugSetting');

      return this.fetchDrugPage(this.searchParams);
    },
    search() {
      const { name, barcode, drugCode } = this.searchParams;
      const params = { name, barcode, pageNo: 1, pageSize: 10 };

      // 只有白名单用户才添加商品编码搜索参数
      if (this.$store.state.drugsManagement.showDrugCode && drugCode) {
        params.drugCode = drugCode;
      }

      return this.fetchDrugPage(params);
    },
    handlePageNo(pageNo) {
      const { name, barcode, drugCode, pageSize } = this.searchParams;
      const params = { name, barcode, pageNo, pageSize };

      // 只有白名单用户才添加商品编码搜索参数
      if (this.$store.state.drugsManagement.showDrugCode && drugCode) {
        params.drugCode = drugCode;
      }

      return this.fetchDrugPage(params);
    },
    handlePageSize(pageSize) {
      const { name, barcode, drugCode, pageNo } = this.searchParams;
      const params = { name, barcode, pageNo, pageSize };

      // 只有白名单用户才添加商品编码搜索参数
      if (this.$store.state.drugsManagement.showDrugCode && drugCode) {
        params.drugCode = drugCode;
      }

      return this.fetchDrugPage(params);
    },
    handleExcelExport() {
      const { name, barcode, drugCode } = this.searchParams;
      const params = { name, barcode };

      // 只有白名单用户才添加商品编码搜索参数
      if (this.$store.state.drugsManagement.showDrugCode && drugCode) {
        params.drugCode = drugCode;
      }

      Fetch.exportDrugByExcel(params).then(res => {
        MessageBox.confirm('文件正在生成中，请前往下载中心进行下载', '数据导出成功', {
          center: true,
          confirmButtonText: '前往下载中心下载',
          cancelButtonText: '稍后下载',
          beforeClose(action, instance, done) {
            switch (action) {
              case 'confirm':
                done();
                router.push('/download');
                break;
              case 'cancel':
              case 'close':
                done();
                break;
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-bar {
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.batch-delete-btn {
  // 正常模式下使用默认样式，不显示红色
  color: #606266;
  border-color: #dcdfe6;

  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.delete-selected-btn {
  // 批量模式下显示蓝色
  background-color: #409eff;
  border-color: #409eff;
  color: #ffffff;

  &:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
  }

  &:disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }
}
</style>
